import * as Sentry from "@sentry/browser";

export type FeatureName =
  | "item-details"
  | "checklist"
  | "scan"
  | "uploading"
  | "processing"
  | "passport-form"
  | "consent-form"
  | "questions"
  | "layout"
  | "login"
  | "error-boundary"
  | "data-provider"
  | "session"
  | "address"
  | "manual-input";

function log(
  featureName: FeatureName,
  paxSessionId: string,
  message: string,
  level: Sentry.SeverityLevel = "error"
) {
  Sentry.withScope((scope) => {
    scope.setLevel(level);
    scope.setTag("feature", featureName);
    Sentry.captureException(
      new Error(`pax_session_id: ${paxSessionId}. ${message}`)
    );
  });
}

const Logging = {
  log,
};

export default Logging;
